import { Component } from '@angular/core';
import {NavItem} from "../../../models/navItem";
import {NavigationEnd, NavigationStart, Router} from "@angular/router";
import {filter} from "rxjs";
import {MissionService} from "../../../services/mission.service";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  navList: NavItem[] = [
    {id: 1, label: 'accueil', icon: 'house', route: 'accueil'},
    {id: 2, label: 'Candidatures', icon: 'candidature',  route: 'candidatures'},
    {id: 3, label: 'Missions', icon: 'missions', route: 'missions'},
    {id: 4, label: 'Planning', icon: 'calendar-check', route: 'planning'},
    {id: 5, label: 'Mon établissement', icon: 'company', route: 'etablissement'},
  ]
  previousUrl: string;

  routeSelected: number | undefined = 1;
  constructor(private router: Router, private missionService: MissionService) {
    const url = router.url;
    router.events.subscribe((val: any) => {
      // see also
      if ( val.url) {
        this.routeSelected = this.navList.find(a => {
          return val.url.includes(a.route)
        } )?.id
      }

    });
  }

  routeClick(item: NavItem) {
    const beforeValidation = this.missionService.getPreviousUrl()?.includes('missions/validation')
    this.router.navigate(['dashboard',item.route])
    this.routeSelected = item.id;

  }
}
